"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayPrice = void 0;
const maps_1 = require("../../../utils/maps");
const DisplayPrice = (props) => {
    const { price, locale, component } = props;
    if (!price)
        return null;
    const displayPrice = (0, maps_1.moneyToDisplayPrice)(price, locale);
    return component({ displayPrice });
};
exports.DisplayPrice = DisplayPrice;
